export const CREATE_SERVICE_CHARGE = "CREATE_SERVICE_CHARGE";
export const FETCH_SERVICE_CHARGES = "FETCH_SERVICE_CHARGES";
export const FETCH_SERVICE_CHARGE = "FETCH_SERVICE_CHARGE";
export const EDIT_SERVICE_CHARGE = "EDIT_SERVICE_CHARGE";
export const DELETE_SERVICE_CHARGE = "DELETE_SERVICE_CHARGE";
export const CREATE_SERVICE_CHARGE_BULK = "CREATE_SERVICE_CHARGE_BULK";
